export enum APP_ROUTES {
  ADMINS = "admins",
  SCRIPTS = "scripts",
  PARTICIPANTS = "participants",
  VIDEOS = "videos",
  PLAYLISTS = "playlists",
  DOCUMENTS = "documents",
  HYDRA = "hydra",
  PERSONAS = "personas",
}
